import React from 'react'

const BtnSpinner = () => {
  return (
    <div className=' w-full h-full'>
        <div class="w-7 h-7 rounded-full animate-spin
        border-y-2 border-solid border-white border-t-transparent shadow-md  mx-auto"></div>
    </div>
  )
} 

export default BtnSpinner;